import * as React from 'react';
import {Tooltip} from 'antd';
import {LockOutlined} from '@ant-design/icons';

interface LockIconProps {
  message: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

export const LockIcon = ({message, onClick}: LockIconProps) => (
  <Tooltip title={message}>
    {/*// TODO removed filled* TODO MM */}
    <LockOutlined style={{color: 'var(--color-tooltip-icon)'}} onClick={onClick} />
  </Tooltip>
);
